import Vue from "vue"

// 以前是
import VueRouter from 'vue-router'
// import { createRouter, createWebHistory } from 'vue-router'
// 还有 createWebHashHistory 和 createMemoryHistory

// 注册路由
Vue.use(VueRouter)

const routes = [
	{
	  path: '/',
	  redirect: "/index",
	  title:'百山祖有奖征集活动'
	},
	{
		path: '/index',
		name: 'index',
		component: () => import('../pages/index/index.vue'),
		meta:{
			title:'首页'
		}
	},
	{
		path: '/graphic',
		name: 'graphic',
		component: () => import('../pages/graphic/index.vue'),
		meta:{
			title:'微图文'
		}
	},
	{
		path: '/active',
		name: 'active',
		component: () => import('../pages/active/index.vue'),
		meta:{
			title:'活动介绍'
		}
	},
	{
		path: '/winners',
		name: 'winners',
		component: () => import('../pages/winners/index.vue'),
		meta:{
			title:'获奖名单'
		},
	},
	,
	{
		path: '/detials',
		name: 'detials',
		component: () => import('../pages/detials/index.vue'),
		meta:{
			title:'作品详情'
		},
	}
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next()
})

// 解决重复跳转到同一个路由报错问题，VueRouter是指路由对象
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

// 导出路由实例化对象
export default router